<template>
  <div @click="$emit('selected')" class="video-component-wrap" v-if="streamManager" :class="classes">
    <video ref="videoRef" autoplay>
      Видео не поддерживается вашим браузером
    </video>
    <div class="video-component-username">
      {{ username }}
    </div>
    <div class="vm-overlay"></div>
    <div class="action-bar">
      <button class="mute-button">
        <i class="material-icons">volume_mute</i>
      </button>
      <button v-if="fullscreen" @click="$emit('exitFullscreen')" class="mute-button">
        <i class="material-icons">fullscreen_exit</i>
      </button>
    </div>
    <div class="status-bar">
      <i class="material-icons">mic_off</i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    streamManager: Object,
    username: String
  },
  computed: {
    classes() {
      return {
        'selected': this.selected,
        'large': this.large,
        'fullscreen': this.fullscreen,
        'active': this.active
      };
    }
  },
  data: () => ({
    mute: false
  }),
  async mounted() {
    console.log('|||', this.streamManager);
    const ref = this.$refs.videoRef;
    await this.streamManager.addVideoElement(ref);
    ref.play();
  },
};
</script>

<style scoped>
.video-component-wrap {
  position: relative;
  width: 100%;
}
.video-component-wrap.fullscreen {
  display: flex;
}
.video-component-wrap .video-component-username {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 4px 8px;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  font-size: 12px;
  line-height: 1;
}
.video-component-wrap.large .video-component-username {
  bottom: 4px;
  left: 4px;
  right: auto;
  font-size: 18px;
}
.video-component-wrap video {
  display: block;
  width: 100%;
}
.video-component-wrap.active .vm-overlay {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0rem;
  border: 2px solid red;
}
.video-component-wrap.selected .vm-overlay {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0rem;
  border: 2px solid blue;
}
.status-bar {
  position: absolute;
  top: 3px;
  left: 3px;
  color: red;
}
.action-bar {
  position: absolute;
  top: 3px;
  right: 3px;
  display: flex;
}
.action-bar button {
  outline: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  border-radius: 50%;
  border: 0;
  height: 32px;
  width: 32px;
}
.action-bar button:hover {
  background: rgba(0, 0, 0, 0.5);
}
</style>